import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { RecaudacionPagoState } from '../../../types-interfaces/interfaces';
import { PaymentModelDetail } from '../../../types-interfaces/types';

const initialState: RecaudacionPagoState = {
  calendarHiddenInicio: true,
  calendarHiddenFin: true,
  entidadRecaudadora: 0,
  medioPago: "0",
  usuarioCreador: '',
  fechaInicio: '',
  fechaFin: '',
  consultaSinDatos: false,  
  paymentsQuantity: 0,
  pagosCLP: 0,
  pagosUSD: 0,  
  errorFechaFin: "",
  errorFechaInicio: "",
  alertText: "",
  alertVariant: undefined,
  errorRut: "",
  rut: '',
  detalleNoRecaudado: [],
  showTableDetalleNoRecaudado: false,
  paymentsIds: []
}

export const recaudacionPagoSlice = createSlice({
  name: 'recaudacionPago',
  initialState: initialState,
  reducers: {
    setRecaudacionPago: (state, action: PayloadAction<RecaudacionPagoState>) => {
      state = action.payload;
    },
    setStringValue: (state, action: PayloadAction<{
      name: "fechaInicio" | "fechaFin" | "errorFechaInicio" | "errorFechaFin" | "rut" | "errorRut" | "medioPago" | "usuarioCreador",
      value: string
    }>) => {
      switch(action.payload.name){
        case "fechaInicio":
          state.fechaInicio = action.payload.value;
          break;
        case "fechaFin":
          state.fechaFin = action.payload.value;
          break;       
        case "errorFechaInicio":
          state.errorFechaInicio = action.payload.value;
          break;
        case "errorFechaFin":
          state.errorFechaFin = action.payload.value;
          break;
        case "rut":
          state.rut = action.payload.value;
          break;
        case "errorRut":
          state.errorRut = action.payload.value;
          break;
        case "medioPago":
          state.medioPago = action.payload.value;
          break;
        case "usuarioCreador":
          state.usuarioCreador = action.payload.value;
          break;     
      }      
    },
    setNumberValue: (
      state,
      action: PayloadAction<{
        name: "entidadRecaudadora" | "medioPago" | "pagosARecaudar" | "pagosCLP" | "pagosUSD",
        value: number
      }>) =>{
      switch(action.payload.name){       
        case "entidadRecaudadora":
          state.entidadRecaudadora = action.payload.value;
          break;
        case "pagosARecaudar":
          state.paymentsQuantity = action.payload.value;
          break;
        case "pagosCLP":
          state.pagosCLP = action.payload.value;
          break;
        case "pagosUSD":
          state.pagosUSD = action.payload.value;
          break;
      }
    },
    setBooleanValue: (
      state,
      action: PayloadAction<{
        name: "calendarHiddenInicio" | "calendarHiddenFin" | "consultaSinDatos" | "showTableDetalleNoRecaudado",
        value: boolean
      }>) => {
      switch(action.payload.name){
        case "calendarHiddenInicio":
          state.calendarHiddenInicio = action.payload.value;
          break;
        case "calendarHiddenFin":
          state.calendarHiddenFin = action.payload.value;
          break;
        case "consultaSinDatos":
          state.consultaSinDatos = action.payload.value;
          break;
        case "showTableDetalleNoRecaudado":
          state.showTableDetalleNoRecaudado = action.payload.value;
          break;
      }
    },    
    setDetalleNoRecaudado:(state, action: PayloadAction<Array<PaymentModelDetail>>) => {
      state.detalleNoRecaudado = action.payload;
    },
    setInitialState:(state) => {      
      state.calendarHiddenInicio = initialState.calendarHiddenInicio;
      state.calendarHiddenFin = initialState.calendarHiddenFin;      
      state.entidadRecaudadora = initialState.entidadRecaudadora;
      state.medioPago = initialState.medioPago;
      state.usuarioCreador = initialState.usuarioCreador;
      state.fechaInicio = initialState.fechaInicio;
      state.fechaFin = initialState.fechaFin;
      state.consultaSinDatos = initialState.consultaSinDatos;      
      state.paymentsQuantity = initialState.paymentsQuantity;
      state.pagosCLP = initialState.pagosCLP;
      state.pagosUSD = initialState.pagosUSD;      
      state.errorFechaInicio = initialState.errorFechaInicio;
      state.errorFechaFin = initialState.errorFechaFin;
      state.alertText = initialState.alertText;
      state.alertVariant = initialState.alertVariant;
      state.rut = initialState.rut;
      state.errorRut = initialState.errorRut;
    },
    setAlert: (state, action: PayloadAction<{
      alertVariant: "error" | "warning" | "information" | "success" | "banner" | undefined,
      alertText: string
    }>) => {
      state.alertText = action.payload.alertText;
      state.alertVariant = action.payload.alertVariant;
    },
    setResumeBox:(state, action: PayloadAction<{paymentsQuantity: number, pagosCLP: number, pagosUSD: number}>) => {
      state.paymentsQuantity = action.payload.paymentsQuantity;
      state.pagosCLP = action.payload.pagosCLP;
      state.pagosUSD = action.payload.pagosUSD;
    },
    setPaymentsIds:(state, action: PayloadAction<{paymentsIds: Array<string>}>) => {
      state.paymentsIds = action.payload.paymentsIds;
    }
  },  
})

export const {
  setRecaudacionPago, setStringValue, setNumberValue, setBooleanValue, setInitialState,
  setAlert, setDetalleNoRecaudado, setResumeBox, setPaymentsIds
} = recaudacionPagoSlice.actions;
export const selectRecaudacionPago = (state: RootState) => state.recaudacionPago;
export default recaudacionPagoSlice.reducer;